/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Meetings} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  meetings: Meetings
}

const MeetingsInfoCell: FC<Props> = ({meetings}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(meetings.id)
  }

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='d-flex flex-column'>
        <a
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {meetings.title}
        </a>
      </div>
    </div>
  )
}

export {MeetingsInfoCell}
